/*
 * @Author: zhangcx33595
 * @Date: 2021-03-26 11:26:08
 * @LastEditors: zhangmh31513
 * @LastEditTime: 2021-09-13 16:50:36
 * @FilePath: \openplat-web-consoled:\gtn2.0-portal.V202109.01.000\openplat-web\src\gtn\store\modules\market.js
 */
const market = {
  state: {
    marking: '0',
    tabKey: 0, // 储存tab,
    isCloud: false
  },
  mutations: {
    SETMARK: (state, data) => {
      state.marking = data.m
    },
    SETTABINDEX: (state, data) => {
      state.tabKey = data.k
    },
    SETCLOUDSTATE: (state, data) => {
      state.isCloud = data.isCloud
    }
  },
  actions: {
    SetMarking: ({ commit }, data) => {
      commit('SETMARK', data)
    },
    SetTabIndex: ({ commit }, data) => {
      commit('SETTABINDEX', data)
    },
    SetCloudState: ({ commit }, data) => {
      commit('SETCLOUDSTATE', data)
    }
  }
}
export default market



// WEBPACK FOOTER //
// ./src/gtn/store/modules/market.js